import Box from '@mui/material/Box';
import { HTMLAttributeAnchorTarget, PropsWithChildren } from 'react';
import { Link as RRDLink, To } from 'react-router-dom';

import { Sxable } from 'library/types';

export interface LinkProps extends PropsWithChildren<Sxable> {
	target?: HTMLAttributeAnchorTarget;
	to: To;
	onClick?: () => void;
}

export const Link = ({
	children,
	className,
	sx = [],
	target,
	to,
	onClick,
}: LinkProps & { className?: string }): React.JSX.Element => (
	<Box
		className={className}
		component={RRDLink}
		to={to}
		sx={sx}
		target={target ?? '_blank'}
		onClick={onClick}>
		{children}
	</Box>
);
